import { render, staticRenderFns } from "./TestatorCard.vue?vue&type=template&id=120605f2"
import script from "./TestatorCard.vue?vue&type=script&lang=js"
export * from "./TestatorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports